import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import SummaryBanner from '../SummaryBanner';

export const DealershipSummary = ({
  remaining,
  totalCartQuantity,
  submitted,
}) => {
  return (
    <div>
      <SummaryBanner
        remaining={remaining}
        inCart={totalCartQuantity}
        submitted={submitted}
      />
    </div>
  );
};

DealershipSummary.propTypes = {
  submitted: PropTypes.number.isRequired,
  remaining: PropTypes.number.isRequired,
  totalCartQuantity: PropTypes.number.isRequired,
};

export default enhance(DealershipSummary);
